import React, { useEffect } from 'react';
import SearchSection from '../SearchSection/SearchSection'
import AboutSection from '../AboutSection/AboutSection'
import Footer from '../../../Footer/Footer'
import PlaylistGroups from '../../../PlaylistGroups/PlaylistGroups'
import styled from 'styled-components'
import { OfflineColor, White } from '../../../../Constants/ColorChart'
import SidePanel from "../../../SidePanel/SidePanel";
import { connect } from 'react-redux'
import isElectron from "is-electron";
import { showBackArrow } from '../../../../../actions/ui'
import { bindActionCreators } from "redux";
import TicketForm from "../../../TicketForm/TicketForm";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { sendAccessLog } from "../../../../../actions/session";
// import Toast from "../../../App/Components/Toast/Toast";
// import CarouselSection from '../CarouselSection/CarouselSection'

/*
 *  @Description:   Component that renders the home page.
 */

const locationIsIL = window.location.host === "docs.instrumentationlaboratory.com";

const StyledDiv = styled.div`
  color: ${ White };
  -webkit-app-region: drag;
  .floatingFixedButton {
    position: fixed;
    top: 30px;
    left: 0;
    z-index: 50;
}
`;

const StyledOffline = styled.div`
    position: fixed;
    top: 60px;
    background: ${ OfflineColor };
    width: 100%;
    color: ${ White };
    text-align: center;
    z-index: 1;
`

const Home = ( props ) => {
    const { isNetworkAvailable/*, isServerReachable*/ } = props;
    const canConnect = isNetworkAvailable //&& isServerReachable;
    const { pushInstruction } = useMatomo ();
    const integradoresReason = localStorage.getItem('integradoresReasons') !== null;
    useEffect ( () => {
        // TODO: Change for a trigger and put in utils.js
        const application = isElectron () ? "- Desktop" : "- Web"
        pushInstruction ( 'setUserId', props.session.user );
        pushInstruction ( 'setReferrerUrl', "" );
        pushInstruction ( 'setCustomUrl', isElectron () ? process.env.REACT_APP_SITE_URL + window.location.pathname : window.location.href );
        pushInstruction ( "setDocumentTitle", "Home Page " );
        pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'visit', "home" );
        pushInstruction ( 'trackPageView' );
        props.showBackArrow ();
        if (!isElectron () && integradoresReason ) {
            {
                let user = localStorage.getItem('username');
                let reason= localStorage.getItem('integradoresReasons');
                let token= localStorage.getItem("token");
                props.sendAccessLogs ( user, reason, token );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <>
            {
                !canConnect &&
                <StyledOffline>OFFLINE</StyledOffline>
            }
            {
                canConnect &&
                <SidePanel/>
            }
            {/*<Toast />*/ }
            <StyledDiv>
                <SearchSection/>
                {
                    !isElectron () &&
                    process.env.REACT_APP_SEE_TICKETS === "1" &&
                    props.session &&
                    props.session.ticketingUUID &&
                    <div className={ "floatingFixedButton" }>
                        <TicketForm/>
                    </div>
                }
                {
                    canConnect &&
                    process.env.REACT_APP_SEE_PLAYLISTGROUPS === "1" &&
                    <PlaylistGroups/>
                }
                {/*
                { <CarouselSection/> }
                */}
                {
                    !locationIsIL &&
                    process.env.REACT_APP_SEE_FAQ === "1" &&
                    <AboutSection/>
                }
                {
                    !locationIsIL &&
                    <Footer/>
                }
            </StyledDiv>
        </>
    );
}

const mapStateToProps = ( state ) => ( {
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable,
    session: state.session
} )
const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators ( {
        showBackArrow: showBackArrow,
        sendAccessLogs : sendAccessLog
  }, dispatch );
}

export default connect ( mapStateToProps, mapDispatchToProps ) ( Home );
